import React from 'react';
import { classNames } from '../helpers/functions';

export const List = ({ children }) => (
	<ul role="list" className="divide-y divide-gray-200">
		{children}
	</ul>
);

export const ListItem = ({ key = '', onClick, children }) => {
	return (
		<li key={key}>
			<div
				onClick={() => (typeof onClick === 'function' ? onClick() : {})}
				className={classNames(
					'block hover:bg-gray-50',
					onClick ? ' cursor-pointer' : ''
				)}
			>
				{children}
			</div>
		</li>
	);
};
